import React, { useRef, InputHTMLAttributes } from "react";

// packages
import classnames from "classnames";

// material ui componetns
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

// styles
import styles from "./styles.module.css";
import "./index.css";
import { ar } from "date-fns/locale";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "value"> {
  value?: Date | null;
  handleChange: (value: any) => void;
  maxDate?: Date;
  minDate?: Date;
  label?: string;
}

const DatePicker: React.FC<Props> = ({
  handleChange,
  maxDate,
  minDate,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={classnames(styles.container)}>
      <LocalizationProvider
        dir="rtl"
        adapterLocale={ar}
        dateAdapter={AdapterDateFns}>
        {!props.value && (
          <label className={styles.placeholder}>{props.placeholder}</label>
        )}
        <DesktopDatePicker
          className={styles.datePicker}
          ref={inputRef}
          label={<p>{props?.label || ""}</p>}
          toolbarPlaceholder={""}
          inputFormat="yyyy/MM/dd"
          value={props.value}
          onChange={(date) => {
            handleChange(date);
          }}
          renderInput={(params) => <TextField {...params} />}
          maxDate={maxDate ? maxDate : null}
          minDate={minDate ? minDate : null}
          PopperProps={{
            placement: "bottom-end",
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default React.memo(DatePicker);
